import PriceListDisplay from './priceListDisplay';

export default PriceListDisplay;
